import { Button } from "@volca/ui/components/ui/button";
import { toast } from "@volca/ui/lib/toast";
import type { ApPurchaseDocument } from "@/accounts-payable/types";

export const CopyPdfLinkButton = ({
  document,
}: {
  document: Pick<ApPurchaseDocument, "shareable_pdf_url">;
}) => {
  const url = document.shareable_pdf_url;
  if (!url) return null;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("PDF link copied", {
        description: "Anyone with the link can open the PDF.",
      });
    } catch {
      toast.error("Couldn't copy the PDF link", {
        description: url,
      });
    }
  };

  return (
    <Button variant="secondary" onClick={() => void copyLink()}>
      Copy PDF link
    </Button>
  );
};
